export * from './src/stores-catalog-v3-inventory-item-inventory-items-v-3.schemas.js';
